import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { X, Menu } from 'lucide-react';

import IconButton from '../IconButton';
import NormalButton from '../NormalButton';
import Tooltip from '../Tooltip';

import LogoImage from '../../../assets/images/Logo_blue_2x.svg';

export default function Header({ activeTab, onSelectMenuBar, menus }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // setActiveTab(location.pathname);
    setOpenMenu(false); // close menu on route change
  }, [location.pathname]);

  const goToPage = (path) => {
    navigate(path);
  };

  const [openMenu, setOpenMenu] = useState(false);

  return (
    <div className="w-full px-12 xl:px-20 py-6 bg-white border border-[#FDFDFD] flex items-center justify-between">
      <img
        src={LogoImage}
        alt="Logo"
        className="min-w-39 w-39 h-17 object-cover"
      />

      {/* Mobile Menu Icon */}
      <button
        onClick={() => setOpenMenu((prev) => !prev)}
        className="block xl:hidden"
      >
        <Menu className="w-8 h-8 text-[#092F7B] cursor-pointer" />
      </button>

      {/* Mobile Dropdown */}
      {openMenu && (
        <div className="fixed inset-0 z-50 xl:hidden">
          {/* Background overlay */}
          <div
            className="absolute inset-0 bg-black/40"
            onClick={() => setOpenMenu(false)} // close on outside click
          />

          {/* Menu panel (right-aligned) */}
          <div className="absolute left-0 top-0 bottom-0 w-full sm:w-100 bg-white shadow-xl px-12 py-6">
            <div className="h-full bg-white flex flex-col justify-between">
              <div className="space-y-8">
                <div className="border border-white flex items-center justify-between">
                  <img
                    src={LogoImage}
                    alt="Logo"
                    className="min-w-39 w-39 h-17 object-cover"
                  />
                  <button onClick={() => setOpenMenu(false)}>
                    <X className="w-7 h-7 text-[#092F7B] cursor-pointer" />
                  </button>
                </div>
                <ul className="space-y-1">
                  {menus.map((data, idx) => (
                    <li
                      key={idx}
                      onClick={() => {
                        onSelectMenuBar(idx);
                        setOpenMenu(false);
                      }}
                      className="w-full  px-4 py-3 w-52 rounded-[12px] cursor-pointer hover:bg-[#E6EBF7] flex items-center justify-center space-x-1 text-[#2A59C6]"
                    >
                      {data.icon('w-7 h-7 text-[#181D27]')}
                      <p className="w-full px-2 text-base tracking-[0%] text-[#181D27] font-bold leading-[20px]">
                        {data.title}
                      </p>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="space-y-2">
                <button
                  className="w-full px-8 py-2.5 min-w-40.5 text-[#092F7B] bg-[#E6EBF7] border border-[#092F7B] rounded-[10px] cursor-pointer leading-[22px] tracking-[0%]"
                  onClick={() => goToPage('/login')}
                >
                  Iniciar sesión
                </button>
                <button
                  className="w-full px-8 py-2.5 text-white bg-[#092F7B] rounded-[10px] cursor-pointer leading-[22px] tracking-[0%]"
                  onClick={() => goToPage('/register')}
                >
                  Registrarse
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Desktop Menu (hidden on mobile) */}
      <div className="hidden xl:flex bg-[#E6EBF780] rounded-[40px] py-4 px-10 space-x-10 items-center justify-center">
        {menus.map((item, idx) => (
          <button
            key={idx}
            style={{ minWidth: item.minWidth }}
            className={`transition-all duration-200 min-w-[134px] text-center cursor-pointer text-base ${
              activeTab == idx
                ? 'text-[#092F7B] font-bold'
                : 'text-[#717680] font-medium'
            }`}
            onClick={() => onSelectMenuBar(idx)}
          >
            {item.title}
          </button>
        ))}
      </div>

      <div className="hidden xl:flex space-x-2 text-base font-medium items-center justify-center">
        <button
          className="px-8 py-2.5 min-w-40.5 text-[#092F7B] bg-[#E6EBF7] border border-[#092F7B] rounded-[10px] cursor-pointer leading-[22px] tracking-[0%]"
          onClick={() => goToPage('/login')}
        >
          Iniciar sesión
        </button>
        <button
          className="px-8 py-2.5 text-white bg-[#092F7B] rounded-[10px] cursor-pointer leading-[22px] tracking-[0%]"
          onClick={() => goToPage('/register')}
        >
          Registrarse
        </button>
      </div>
    </div>
  );
}
